import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import React, { useEffect, useState } from 'react';
import { StateModel, StateModel_Admin } from '../../../../redux/store';
import { connect } from 'react-redux';
import { Mandant } from '../../../../api';
import Modal from '../../../../components/modal/Modal';
import {
  getFreieMandanten,
  getHauptmandanten,
  getUntermandanten,
  updateMandant,
} from '../../../../redux/actions/admin';
import Button from '../../../../components/button/Button';
import Toolbar from '../../../../components/toolbar/Toolbar';

interface HauptmandantenProps {
  admin: StateModel_Admin;
  getHauptmandanten: (search: string) => void;
  getUntermandanten: (id: number, search: string) => void;
  getFreieMandanten: (search: string) => void;
  updateMandant: (
    id: number,
    mandant: Mandant,
    isHauptmandant: boolean
  ) => void;
}

const Hauptmandanten = (props: HauptmandantenProps) => {
  const [show, setShowModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const [links, setLinks] = useState(false);
  const [hauptMandanten, setHauptMandanten] = useState<Array<any>>([{}]);
  const [currentUnterMandanten, setCurrentUnterMandanten] = useState<
    Array<any>
  >([{}]);
  const [freieMandanten, setFreieMandanten] = useState<Array<any>>([{}]);
  const [selectedHauptmandant, setSelectedHauptmandant] = useState<number>(-1);
  const [selectedUntermandant, setSelectedUntermandant] = useState<number>(-1);
  const [selectedMandant, setSelectedMandant] = useState<number>(-1);

  const [searchHMString, setSearchHMString] = useState('');
  const [searchUMString, setSearchUMString] = useState('');
  const [searchFMString, setSearchFMString] = useState('');
  const minInput = 'mindestens 2 Zeichen angeben';
  const minSearchLenght = 2;

  useEffect(() => {
    props.getHauptmandanten(searchHMString);
    props.getFreieMandanten(searchFMString);
  }, [props.admin.reloadHauptmandanten]);

  useEffect(() => {
    props.getUntermandanten(selectedHauptmandant, searchUMString);
    props.getFreieMandanten(searchFMString);
  }, [props.admin.reloadUntermandanten]);

  useEffect(() => {
    const newHauptMandanten = [...props.admin.hauptMandanten];
    setHauptMandanten(newHauptMandanten);
  }, [props.admin.hauptMandanten]);

  useEffect(() => {
    const newCurrentUnterMandanten = [...props.admin.currentUnterMandanten];
    setCurrentUnterMandanten(newCurrentUnterMandanten);
  }, [props.admin.currentUnterMandanten]);

  useEffect(() => {
    const newFreieMandanten = [...props.admin.freieMandanten];
    setFreieMandanten(newFreieMandanten);

    if (!links) {
      const ncm = [...props.admin.currentUnterMandanten];
      setCurrentUnterMandanten(ncm);
    }
  }, [props.admin.freieMandanten]);

  useEffect(() => {
    if (searchstringOK(searchHMString)) props.getHauptmandanten(searchHMString);
  }, [searchHMString]);

  useEffect(() => {
    if (searchstringOK(searchUMString))
      props.getUntermandanten(selectedHauptmandant, searchUMString);
  }, [searchUMString]);

  useEffect(() => {
    if (searchstringOK(searchFMString)) props.getFreieMandanten(searchFMString);
  }, [searchFMString]);

  const ladeMandanten = (id: number | undefined) => {
    setSelectedHauptmandant(id ?? -1);
    setSelectedUntermandant(-1);
    props.getUntermandanten(id ?? -1, searchUMString);
  };

  const isSelected = (id1: number | undefined, id2: number | undefined) => {
    return id1 === id2;
  };
  const searchstringOK = (searchstring: string | undefined) => {
    return (
      !searchstring ||
      searchstring.length == 0 ||
      searchstring.length >= minSearchLenght
    );
  };
  const neuerHauptmandant = () => {
    props.getFreieMandanten(searchFMString);
    setShowModal(true);
    setLinks(true);
  };
  const neuerUntermandant = () => {
    props.getFreieMandanten(searchFMString);
    setShowModal(true);
    setLinks(false);
  };

  const updateMandantForHauptmandant = (mand_id: number) => {
    const newFreieMandanten = [...props.admin.freieMandanten];
    const mandant = newFreieMandanten.find(mandant => mandant.id === mand_id);
    if (mandant) {
      mandant.hauptmandantId = mand_id;
      props.updateMandant(mand_id, mandant, true);
    }
    setShowModal(false);
  };

  const removeHauptmandant = (mand_id: number) => {
    if (currentUnterMandanten.length <= 0) {
      const mandant = props.admin.hauptMandanten.find(
        mandant => mandant.id === mand_id
      );
      if (mandant) {
        mandant.hauptmandantId = undefined;
        props.updateMandant(mand_id, mandant, true);
      }
    } else {
      setShowWarning(true);
    }
  };

  const updateMandantForUntermandant = (mand_id: number) => {
    const newUnterMandanten = [...props.admin.freieMandanten];
    const mandant = newUnterMandanten.find(mandant => mandant.id === mand_id);
    if (mandant) {
      mandant.hauptmandantId = selectedHauptmandant;
      props.updateMandant(mand_id, mandant, false);
    }
    setShowModal(false);
  };
  const removeUntermandant = (mand_id: number) => {
    const mandant = props.admin.currentUnterMandanten.find(
      mandant => mandant.id === mand_id
    );
    if (mandant) {
      mandant.hauptmandantId = undefined;
      props.updateMandant(mand_id, mandant, false);
    }
  };

  /**
   * Steuert die Schließung vom Modalen Fenster und leert den State der Felder.
   */
  const handleClose = () => {
    setShowModal(false);
    setShowWarning(false);
  };

  const hauptmandantenList = (hm: Mandant) => {
    return (
      <li
        key={`hm: ${hm.id}`}
        title={`${hm.name}\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n${
          hm.adresse?.matchcode
        }\n${hm.adresse?.name}\n${hm.adresse?.zeile2 ?? ''}\n${
          hm.adresse?.strasse
        } ${hm.adresse?.hausnummer ?? ''}\n${hm.adresse?.land?.lkz} - ${
          hm.adresse?.plz
        } ${hm.adresse?.ort}`}
        className={`select-list-option ${
          isSelected(selectedHauptmandant, hm.id) && 'selected'
        }`}
        onClick={() => {
          ladeMandanten(hm.id);
          setSearchUMString('');
        }}
      >
        {` ${hm.name} (${hm.adresse?.matchcode})`}
      </li>
    );
  };
  const unterMandantenList = (mandant: Mandant) => {
    return (
      <li
        key={`md: ${mandant.id}`}
        title={`${mandant.name}\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n${
          mandant.adresse?.matchcode
        }\n${mandant.adresse?.name}\n${mandant.adresse?.zeile2 ?? ''}\n${
          mandant.adresse?.strasse
        } ${mandant.adresse?.hausnummer ?? ''}\n${
          mandant.adresse?.land?.lkz
        } - ${mandant.adresse?.plz} ${mandant.adresse?.ort}`}
        className={`select-list-option ${
          isSelected(selectedUntermandant, mandant.id) && 'selected'
        }`}
        onClick={() => {
          setSelectedUntermandant(mandant.id ?? -1);
        }}
      >
        {` ${mandant.name} (${mandant.adresse?.matchcode})`}
      </li>
    );
  };
  const freieMandantenList = (mandant: Mandant) => {
    return (
      <li
        key={`frei: ${mandant.id}`}
        title={`${mandant.name}\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n${
          mandant.adresse?.matchcode
        }\n${mandant.adresse?.name}\n${mandant.adresse?.zeile2 ?? ''}\n${
          mandant.adresse?.strasse
        } ${mandant.adresse?.hausnummer ?? ''}\n${
          mandant.adresse?.land?.lkz
        } - ${mandant.adresse?.plz} ${mandant.adresse?.ort}`}
        className={`select-list-option ${
          isSelected(selectedMandant, mandant.id) && 'selected'
        }`}
        onClick={() => {
          setSelectedMandant(mandant.id ?? -1);
        }}
      >
        {` ${mandant.name} (${mandant.adresse?.matchcode})`}
      </li>
    );
  };
  return (
    <GridCellWrapper
      classes='mandant'
      label='Hauptmandantenverwaltung und Mandantenzuordnung'
    >
      <div className='mandantencontent'>
        <div className='hauptmandanten'>
          &nbsp; Hauptmandanten
          <div className={'mandanten-search-liste'}>
            <div className='listen'>
              <Toolbar>
                <div className='searchbar'>
                  <i className='fas fa-search fa-lg' />
                  <input
                    type='text'
                    placeholder={'...'}
                    id='search-input'
                    title={minInput}
                    value={searchHMString}
                    onChange={e => setSearchHMString(e.target.value)}
                  />
                </div>
              </Toolbar>
              <ul>
                {hauptMandanten.map(hm => {
                  return hauptmandantenList(hm);
                })}
              </ul>
            </div>

            <div className='icons'>
              <Button
                tooltip='neuen Hauptmandant anlegen'
                classes={'iconButton'}
                key={0}
                onClickHandler={() => {
                  neuerHauptmandant();
                }}
              >
                <i className='fas fa-plus' />
              </Button>
              <br />
              <Button
                tooltip='kein Hauptmandant mehr'
                classes={'iconButton'}
                key={1}
                onClickHandler={() => {
                  removeHauptmandant(selectedHauptmandant);
                }}
              >
                <i className='fas fa-minus' />
              </Button>
            </div>
          </div>
        </div>
        <div className='mandanten'>
          &nbsp; Mandanten
          <div className={'mandanten-search-liste'}>
            <div className='listen'>
              <Toolbar>
                <div className='searchbar'>
                  <i className='fas fa-search fa-lg' />
                  <input
                    type='text'
                    placeholder={'...'}
                    id='search-input'
                    title={minInput}
                    value={searchUMString}
                    onChange={e => setSearchUMString(e.target.value)}
                  />
                </div>
              </Toolbar>
              <ul>
                {currentUnterMandanten.map(cm => {
                  return unterMandantenList(cm);
                })}
              </ul>
            </div>
            <div className='icons'>
              {!!(selectedHauptmandant > 0) && (
                <Button
                  tooltip='Untermandant auswählen '
                  classes={'iconButton'}
                  key={2}
                  onClickHandler={() => {
                    neuerUntermandant();
                  }}
                >
                  <i className='fas fa-plus' />
                </Button>
              )}
              <br />
              {!!(selectedUntermandant > 0) && (
                <Button
                  tooltip='kein Untermandant mehr'
                  classes={'iconButton'}
                  key={3}
                  onClickHandler={() => {
                    removeUntermandant(selectedUntermandant);
                  }}
                >
                  <i className='fas fa-minus' />
                </Button>
              )}
            </div>
          </div>
        </div>
        <Modal
          show={show}
          closeHandler={() => setShowModal(false)}
          titel='Mandant auswählen'
        >
          <div className='modalliste'>
            <Toolbar>
              <div className='searchbar'>
                <i className='fas fa-search fa-lg' />
                <input
                  type='text'
                  placeholder={'...'}
                  title={minInput}
                  id='search-input'
                  value={searchFMString}
                  onChange={e => setSearchFMString(e.target.value)}
                />
              </div>
            </Toolbar>
            <ul>
              {freieMandanten.map(fm => {
                return freieMandantenList(fm);
              })}
            </ul>
          </div>
          <div className='modal-btn-group'>
            <button
              className='modal-btn'
              key={4}
              onClick={() => {
                links === true
                  ? updateMandantForHauptmandant(selectedMandant)
                  : updateMandantForUntermandant(selectedMandant);
              }}
            >
              OK
            </button>
            <button className='modal-btn' key={5} onClick={() => handleClose()}>
              Abbrechen
            </button>
          </div>
        </Modal>
        <Modal
          show={showWarning}
          closeHandler={() => setShowModal(false)}
          titel='Achtung'
        >
          <div className={'hm-warning'}>
            Bitte entfernen Sie zuerst alle zugeordneten Untermandanten.
          </div>
          <div className='modal-btn-group'>
            <button className='modal-btn' key={6} onClick={() => handleClose()}>
              OK
            </button>
          </div>
        </Modal>
      </div>
    </GridCellWrapper>
  );
};
const mapStateToProps = (state: StateModel) => ({
  admin: state.Admin,
});

export default connect(mapStateToProps, {
  getHauptmandanten,
  getUntermandanten,
  getFreieMandanten,
  updateMandant,
})(Hauptmandanten);
